import api from './api';

/**
 * User management service
 * All endpoints require admin authentication
 */

/**
 * Get all users with optional filters
 * @param {Object} params - Query parameters (admin, search, order_by, order_direction, per_page)
 * @returns {Promise}
 */
export const getUsers = (params = {}) => {
  return api.get('/api/users', { params });
};

/**
 * Get a specific user by ID
 * @param {number} id - User ID
 * @returns {Promise}
 */
export const getUser = (id) => {
  return api.get(`/api/users/${id}`);
};

/**
 * Create a new user
 * @param {Object} userData - User data (name, email, password, admin, plan_id)
 * @returns {Promise}
 */
export const createUser = (userData) => {
  return api.post('/api/users', userData);
};

/**
 * Update an existing user
 * @param {number} id - User ID
 * @param {Object} userData - User data to update
 * @returns {Promise}
 */
export const updateUser = (id, userData) => {
  return api.put(`/api/users/${id}`, userData);
};

/**
 * Delete a user
 * @param {number} id - User ID
 * @returns {Promise}
 */
export const deleteUser = (id) => {
  return api.delete(`/api/users/${id}`);
};

/**
 * Get user statistics
 * @returns {Promise}
 */
export const getUserStats = () => {
  return api.get('/api/users/stats');
};
